import { render, staticRenderFns } from "./CardLinks.vue?vue&type=template&id=5405c307&"
import script from "./CardLinks.vue?vue&type=script&lang=js&"
export * from "./CardLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports